import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Voorwaarden from './views/Voorwaarden.vue'
// import Secondary from './views/Secondary.vue'
// import Login from './views/Login.vue'
// import Signup from './views/Signup.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/algemene-voorwaarden',
      name: 'voorwaarden',
      component: Voorwaarden,
    },
    // {
    //   path: '/secondary',
    //   name: 'secondary',
    //   component: Secondary
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },
  ],
  mode: 'history',
})
